module.exports = __webpack_public_path__ + "static/ecommerce-mobile-room-299b2ecd0b728116b679b1098b3598fa.png";